import { SrsStore } from './useSrsStore'

const isBrandedStore = (store: SrsStore | undefined) =>
    Boolean(store && (store.ciStore || store.pmeStore || store.jbStore))

export default isBrandedStore
